const checkIsValidFeeTemplateRange = (
	min: number | string | null,
	max: number | string | null,
): boolean => {
	return !!(min || max);
};

export const rangeValidator = (required = false) => ({
	rangeValidator: (_min, _max) => value => {
		const _value = Number(value);
		if (checkIsValidFeeTemplateRange(_min, _max)) {
			const valueNotSet = !_value && value !== "0.000000";
			const notInRange = _value < _min || _value > _max;
			if (valueNotSet || notInRange) {
				return {
					message: `Allowed range from ${_min} to ${_max}`,
					isRequired: required,
				};
			}
		}
	},
});
